import {
    PageTemplates,
    isPageTemplate,
} from "@utils/configuration/pageTemplate.helpers";

import { Facet } from "./Facet/@types/facet.types";
import { FacetType } from "./Facet/@types/facetType.types";

type FacetFilterFn = (facet: Facet<FacetType>) => boolean;

const isCategoryPage = isPageTemplate(PageTemplates.PRODUCT_CATEGORY);

const hierarchicalFacetFilter = (facet: Facet<FacetType>) => {
    const hasChildren =
        Object.keys(facet.values).length > 0 &&
        Object.keys(Object.values(facet.values).at(0)?.childValues || {})
            .length > 0;

    return !(isCategoryPage && !hasChildren);
};

const FiltersMap: Partial<Record<FacetType, FacetFilterFn>> = {
    [FacetType.HIERARCHICAL]: hierarchicalFacetFilter,
};

export const filterFacets = (facet: Facet<FacetType>) => {
    const filter = FiltersMap[facet.type];
    if (filter) {
        return filter(facet);
    }

    return true;
};
